import React from 'react'
import {Checkbox, Icon} from '@fluentui/react';

class LevelList extends React.Component {
    constructor() {
        super();
        this.state = {
            expandIconHovered: false,
            childrenExpanded: null,
            children: []
        }
    }
    getMyChildren() {
        let key = this.state.childrenExpanded;
        let array = this.props.allTreeItems.filter(x => x.parentKey === key)
        this.setState({children: array})
    }

    componentWillUnmount(): void {
        // this.props.manageActiveItems("remove",this.props.items);
    }

    getTextFromItem(item) {
        const text = item.key === 'Cross' ? item.value : `${item.key} - ${item.value}`;
        if (text.length > 26) {
            return text.substring(0, 24) + '...';
        }
        return text;
    }

    isSelected(key) {
        if (this.props.selection.length === 0) return false;
        return this.props.selection.filter(x => x.key === key).length !== 0
    }

    select(item) {
        this.props.select(item);
    }

    expandChildren(key) {
        if (key === this.state.childrenExpanded) {
            this.setState({childrenExpanded: null});
            return;
        }
        this.setState({childrenExpanded: key}, () => this.getMyChildren())
    }

    isMyChildSelected(key) {
        let path = [];
        this.props.selection.forEach(x => {
            this.itemPath(x.parentKey, []).forEach(x => path.push(x));
        })

        if (path.filter(x => x.key === key).length !== 0) return true;
        return false;
    }

    itemPath(parentKey, path) {
        const allItems = this.props.allTreeItems;
        if (parentKey !== 'ABB') {
            const parent = allItems.filter(x => x.key === parentKey)[0];
            path.push(parent);
            this.itemPath(parent.parentKey, path)
        }
        return path;
    }

    itemExpanded(key) {
        return this.state.childrenExpanded === key;
    }

    hoverIcon() {
        this.setState({expandedIconHovered: !this.state.expandedIconHovered})
    }

    render() {
        const iconStyl = !this.state.expandedIconHovered ? iconStyle : iconStyleHover
        const firstLevel = this.props.items.map(x =>
            <div key={x.key} style={this.isSelected(x.key) || this.isMyChildSelected(x.key) || this.props.childMark ?
                {position: 'relative', backgroundColor: 'rgb(237, 235, 233)'} :
                {position: 'relative', backgroundColor: 'white'}}
            >
                <div style={{position: 'absolute', left: '230px', zIndex: 1}}> {this.itemExpanded.bind(this)(x.key) &&
                <LevelList
                    key={x.key}
                    childMark={this.isSelected(x.key) || this.props.childMark}
                    items={this.state.children}
                    selection={this.props.selection}
                    allTreeItems={this.props.allTreeItems}
                    select={this.props.select}
                    address={this.props.address}
                />
                }
                </div>
                <div style={listElement}>
                    <div style={{padding: '4px 4px 4px 4px'}}>
                        {x.isParent && <Icon style={iconStyl} onMouseLeave={this.hoverIcon.bind(this)}
                                             onMouseEnter={this.hoverIcon.bind(this)}
                                             onClick={() => this.expandChildren(x.key)} iconName="ChevronRightMed"/>}
                        <Checkbox checked={this.isSelected(x.key) || this.props.childMark}
                                  childMark={this.isSelected(x.key) || this.props.childMark}
                                  onChange={() => this.select(x)} style={checkboxStyle}
                                  label={this.getTextFromItem(x)}/></div>
                </div>
            </div>
        );
        return (
            <div>
                {
                    <div style={deepLevelStyle}>
                        {firstLevel}
                    </div>
                }
            </div>
        );
    }
}

const deepLevelStyle = {
    boxShadow: 'rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px'
}

const checkboxStyle =
    {
        width: '80px',
    }

const iconStyle =
    {
        position: 'relative',
        float: 'right',
        fontSize: 12,
        margin: '3px',
        marginRight: '2px'
    }

const iconStyleHover =
    {
        position: 'relative',
        float: 'right',
        fontSize: 12,
        margin: '3px',
        cursor: 'pointer',
        marginRight: '2px'
    }

const listElement = {

    height: '28px',
    width: '230px',
}
export default LevelList


// WEBPACK FOOTER //
// ./src/components/CustomComponents/LevelList.js